import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SubProductModel } from 'hx-services';
import { NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { HxLabelEditComponent, HxProductInfoSelectComponent } from 'hx-components';
import { NzIconDirective } from 'ng-zorro-antd/icon';

import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

@Component({
    selector: 'hc-subproduct-edit',
    templateUrl: './subproduct-edit.component.html',
    styleUrls: ['./subproduct-edit.component.less'],
  imports: [TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, HxProductInfoSelectComponent, HxLabelEditComponent, NzIconDirective, NzTooltipDirective, NzInputNumberComponent, NzModalFooterDirective, NzButtonComponent, NzWaveDirective]
})
export class SubProductEditComponent implements OnInit {
  @Input() subProduct?: SubProductModel;
  subProductForm!: UntypedFormGroup;

  constructor(
    public modalRef: NzModalRef,
    private fb: UntypedFormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.subProductForm = this.fb.group({
      productDefinitionId: [null, [Validators.required]],
      sortOrder: [null],
      priceAmount: [1.0, [Validators.required]],
      title: [null, Validators.required],
    });
    if (this.subProduct) {
      this.subProductForm.patchValue(this.subProduct);
    }
  }

  submitForm() {
    this.modalRef.close(this.subProductForm.value as SubProductModel);
  }
}
